//Notification settings
export const FETCH_NOTIFICATION_SETTING =
	'notification-settings/GET_NOTIFICATION_SETTING';
export const SET_PORTAL_SETTINGS = 'notification-settings/SET_PORTAL_SETTINGS';
export type Action =
	| { type: FETCH_NOTIFICATION_SETTING }
	| { type: SET_PORTAL_SETTINGS, data: Object };



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/action-types.js